import { render } from "./DesignTemplate.vue?vue&type=template&id=54c7e602&scoped=true"
import script from "./DesignTemplate.vue?vue&type=script&lang=js"
export * from "./DesignTemplate.vue?vue&type=script&lang=js"

import "./DesignTemplate.vue?vue&type=style&index=0&id=54c7e602&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c7e602"]])

export default __exports__